import { Modal } from "antd";
import { api } from "../../../api";
import { useState } from "react";
import { useDispatch } from "react-redux";
import { WorkspaceFile, WorkspaceFolder } from "../../../types";
import { sendError, sendMessage } from "@util/helpers/notifications.helper";
import { CustomInput } from "@components/FormFields";
import { FormikHelpers, useFormik } from "formik";
import * as Yup from 'yup';
import { updateWorkspaceItem } from "@store/workspace";

const validationSchema = Yup.object().shape({
  title: Yup.string().required('Folder name is required!'),
});

interface FormType {
  title: string;
}

interface Props {
  visible: boolean;
  item: WorkspaceFolder | WorkspaceFile;
  onCancel: () => void;
}

export const RenameModal = ({ visible, item, onCancel }: Props) => {
  const dispatch = useDispatch();

  const [loading, setLoading] = useState(false);

  const onSubmit = async ({ title }: FormType, { resetForm }: FormikHelpers<FormType>) => {
    if (!item?.id) return;

    setLoading(true);

    try {
      const isFile = !!(item as WorkspaceFile)?.s3Key;
      const url = `/workspaces/${isFile ? 'files' : 'folders'}/${item.id}`;
      const { data } = await api.patch<WorkspaceFile | WorkspaceFolder>(url, { title })
      if (!data) throw new Error('Unable to duplicate file!');

      dispatch(updateWorkspaceItem(data));
      sendMessage('Item updated successfully!');

      resetForm();
      onCancel();
    } catch (err) {
      sendError(err);
    } finally {
      setLoading(false);
    }
  };

  const formik = useFormik<FormType>({
    initialValues: { title: item?.title || '' },
    onSubmit,
    validationSchema,
  });

  return (
    <form onSubmit={formik.handleSubmit}>
      <Modal
        title="Rename Item"
        visible={visible}
        onCancel={onCancel}
        okButtonProps={{ loading, onClick: () => formik.handleSubmit() }}
      >
        <div>
          <CustomInput
            name="title"
            formik={formik}
            placeholder="New file name"
            onPressEnter={formik.submitForm}
          />
        </div>
      </Modal>
    </form>
  );
};
